import src from "IMAGE";
export default { src, width: 1413, height: 270, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAALUlEQVR42i3FpxEAMAwEwedOxAnbSKP++9MBgZ2VpIqSGxwDHQ2aOFjY6eHjBij5AWvauDyqAAAAAElFTkSuQmCC"};
